import * as Turbo from '@hotwired/turbo';
import SmoothScroll from 'smoothscroll-polyfill';
import { Application } from '@hotwired/stimulus';

import '@shoelace-style/shoelace/dist/components/icon/icon.js';
import { registerIconLibrary } from '@shoelace-style/shoelace/dist/utilities/icon-library.js';

registerIconLibrary('default', {
  resolver: (name) => `https://static-app-misc.banzai.org/icon-library/${name}.svg`,
});

import SidebarController from 'banzai/manager/front/shared/components/sidenav/controller.js';
import FrameSuspenseController from 'banzai/manager/front/shared/components/turbo-frame-suspense/controller.js';
import ArticleVisitsChartController from 'banzai/manager/front/reports/articles/chart_controller.js';
import VideoVisitsChartController from 'banzai/manager/front/reports/videos/chart_controller.js';
import CalculatorUsesChartController from 'banzai/manager/front/reports/calculators/chart_controller.js';
import CoachSessionsChartController from 'banzai/manager/front/reports/coaches/chart_controller.js';
import CourseSessionsChartController from 'banzai/manager/front/reports/courses/chart_controller.js';
import FwaAssessmentUsageChartController from 'banzai/manager/front/reports/fwa/chart_controller.js';
import FwaTableSortController from 'banzai/manager/front/reports/fwa/fwa_table_sort_controller.js';
import OrderWorkbookChartController from 'banzai/manager/front/reports/orders/workbook_chart_controller.js';
import OrderReorderChartController from 'banzai/manager/front/reports/orders/reorder_chart_controller.js';
import UserSignupsChartController from 'banzai/manager/front/reports/courses/chart_controller.js';
import EmbeddedController from 'banzai/manager/front/content/controller.js';
import MinimizerController from 'banzai/manager/front/shared/javascript/minimizer_controller.js';
import Posthog from 'banzai/manager/front/shared/javascript/posthog.js';
import EmailDetailController from 'banzai/manager/front/reports/teachers/email_detail_controller.js';
import EmailTemplateController from 'banzai/manager/front/reports/teachers/teacher/email/email_template_controller.js';
import ClipboardController from 'banzai/manager/front/shared/javascript/clipboard_controller.js';
import RewardsTableSortController from 'banzai/manager/front/reports/rewards/rewards_table_sort_controller.js';
import UserEngagementTableController from 'banzai/manager/front/reports/rewards/user_engagement_table_controller.js';
import CopyEmailsController from 'banzai/manager/front/reports/rewards/copy_emails_controller.js';

// Stimulus setup
window.Stimulus = Application.start();
Stimulus.register('sidebar', SidebarController);
Stimulus.register('turbo-frame-suspense', FrameSuspenseController);
Stimulus.register('article-visits-chart', ArticleVisitsChartController);
Stimulus.register('video-visits-chart', VideoVisitsChartController);
Stimulus.register('calculator-uses-chart', CalculatorUsesChartController);
Stimulus.register('coach-sessions-chart', CoachSessionsChartController);
Stimulus.register('course-sessions-chart', CourseSessionsChartController);
Stimulus.register('fwa-assessment-usage-chart', FwaAssessmentUsageChartController);
Stimulus.register('fwa-table-sort', FwaTableSortController);
Stimulus.register('workbook-breakdown-chart', OrderWorkbookChartController);
Stimulus.register('reorder-breakdown-chart', OrderReorderChartController);
Stimulus.register('user-signups-chart', UserSignupsChartController);
Stimulus.register('embedded', EmbeddedController);
Stimulus.register('minimizer', MinimizerController);
Stimulus.register('email-detail', EmailDetailController);
Stimulus.register('email-template', EmailTemplateController);
Stimulus.register('clipboard', ClipboardController);
Stimulus.register('rewards-table-sort', RewardsTableSortController);
Stimulus.register('user-engagement-table', UserEngagementTableController);
Stimulus.register('copy-emails', CopyEmailsController);

SmoothScroll.polyfill();

posthog.init('phc_i4cMUEVi6V2u4ixLchBTbLckiWs6J8PziNwNjpnpDxj', {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
});

if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
  Posthog.opt_out_capturing();
}
